import MyFilesView from "@features/tools/view/my-files-view";

const MyFiles = () => {
  return <MyFilesView />;
};

export default MyFiles;
